/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Mcp_Server_Development_Tlm_0Inputs */

const en_svc_mcp_server_development_tlm_0 = /** @type {(inputs: Svc_Mcp_Server_Development_Tlm_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`transport`)
};

const ar_svc_mcp_server_development_tlm_0 = /** @type {(inputs: Svc_Mcp_Server_Development_Tlm_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`النقل`)
};

const bn_svc_mcp_server_development_tlm_0 = /** @type {(inputs: Svc_Mcp_Server_Development_Tlm_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`পরিবহন`)
};

const de_svc_mcp_server_development_tlm_0 = /** @type {(inputs: Svc_Mcp_Server_Development_Tlm_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Transport`)
};

const es_svc_mcp_server_development_tlm_0 = /** @type {(inputs: Svc_Mcp_Server_Development_Tlm_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Transporte`)
};

const fr_svc_mcp_server_development_tlm_0 = /** @type {(inputs: Svc_Mcp_Server_Development_Tlm_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Transport`)
};

const pt_svc_mcp_server_development_tlm_0 = /** @type {(inputs: Svc_Mcp_Server_Development_Tlm_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Transporte`)
};

const zh_svc_mcp_server_development_tlm_0 = /** @type {(inputs: Svc_Mcp_Server_Development_Tlm_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`传输`)
};

const tr_svc_mcp_server_development_tlm_0 = /** @type {(inputs: Svc_Mcp_Server_Development_Tlm_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Taşıma`)
};

const ru_svc_mcp_server_development_tlm_0 = /** @type {(inputs: Svc_Mcp_Server_Development_Tlm_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Транспорт`)
};

const pl_svc_mcp_server_development_tlm_0 = /** @type {(inputs: Svc_Mcp_Server_Development_Tlm_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Transport`)
};

/**
* | output |
* | --- |
* | "transport" |
*
* @param {Svc_Mcp_Server_Development_Tlm_0Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_mcp_server_development_tlm_0 = /** @type {((inputs?: Svc_Mcp_Server_Development_Tlm_0Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Mcp_Server_Development_Tlm_0Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_mcp_server_development_tlm_0(inputs)
	if (locale === "bn") return bn_svc_mcp_server_development_tlm_0(inputs)
	if (locale === "de") return de_svc_mcp_server_development_tlm_0(inputs)
	if (locale === "es") return es_svc_mcp_server_development_tlm_0(inputs)
	if (locale === "fr") return fr_svc_mcp_server_development_tlm_0(inputs)
	if (locale === "pt") return pt_svc_mcp_server_development_tlm_0(inputs)
	if (locale === "zh") return zh_svc_mcp_server_development_tlm_0(inputs)
	if (locale === "tr") return tr_svc_mcp_server_development_tlm_0(inputs)
	if (locale === "ru") return ru_svc_mcp_server_development_tlm_0(inputs)
	if (locale === "pl") return pl_svc_mcp_server_development_tlm_0(inputs)
	return en_svc_mcp_server_development_tlm_0(inputs)
});
export { svc_mcp_server_development_tlm_0 as "svc_mcp-server-development_tlm_0" }